import React, { memo } from "react";
// import ReactGA from "react-ga";
import { UiButton } from "~/components/elements";

export const SendContactMessage = memo(
  ({ onClickSendContactBtn, loading }: { onClickSendContactBtn: () => void; loading?: boolean }) => {
    const onSubmit = () => {
      // ReactGA.event({
      //   category: "Contact us",
      //   action: "Click on Send message btn",
      //   label: "Contact label",
      // });
      onClickSendContactBtn();
    };

    return (
      <UiButton mt="10px" onClick={onSubmit} py={3} colorScheme="teal" isLoading={loading} size="lg">
        Send Message
      </UiButton>
    );
  }
);
